import { Box, Button, CircularProgress, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import SimpleAutoComplete from "src/components/auto-complete/autocomplete-dialog-with-z-index";

import { getDataRequestById, getMethodAuthIntegration, testAuthentication, testRequestIntegrationService } from "src/services/integrationservice.service";

import ApiResponseDisplay from "src/pages/authentication-edit/components/api-response-display";
import { Overlay } from "src/styles/global";
import extractPrimitives from "src/utils/functions/extract-primitives";
import styled from 'styled-components';
import EditableTableCustomFields from "./editable-table-custom-fields";
import "./styles.css";

import * as IntegrationServiceCustomFieldService from "../../../services/integration-service-custom-field.service";

const StyledTextField = styled(TextField)`
  width: 100%;
`;

const RequestIntegrationService = ({
  token,
  integrationServiceId,
  isOpenFromJoint = false
}) => {
  const [url, setUrl] = useState("");

  const intl = useIntl();

  const [loading, setLoading] = useState(true);

  // Data auth
  const [methodAuthIntegrationService, setMethodAuthIntegrationService] = useState({id: null, name: ""});
  const [basicAuthUser, setBasicUser] = useState('');
  const [basicAuthPassword, setBasicAuthPassword] =  useState('');
  const [methodAuthList, setMethodAuthList] = useState('');
  const [_token, setToken] = useState('');


  // Data request
  const [params, setParams] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [requestBody, setRequestBody] = useState([]);
  const [jsonValue, setJsonValue] = useState('');
  const [jsonError, setJsonError] = useState('');

  const [showContentRequest, setShowContentRequest] = useState(false);
  const [statusRequest, setStatusRequest] = useState('');
  const [contentRequest, setContentRequest] = useState('');

  const [loadDataComponent, setLoadDataComponente] = useState(false);

  // Data service Integration
  const [data, setData] = useState({});

  // Campos personalizados
  const [customFields, setCustomFields] = useState([]);

  const getToken = async (id) => {
    try {
      setLoading(true);

      if (id == 0 || id == null) {
        return "";
      } else {
        const formData = {
          integrationauthid: id
        }
  
        var result = await testAuthentication(formData)
  
        if (result && result.data && result.success) {
          try {
            if (result.data.success) {
              const jsonData = JSON.parse(result.data.content);
              
              const accessTokenFieldName = result.data && result.data.accesstokenfieldname ? result.data.accesstokenfieldname : ''
              
              var content = jsonData.data && jsonData.data[accessTokenFieldName] != null ? jsonData.data[accessTokenFieldName] : jsonData[accessTokenFieldName] != null ? jsonData[accessTokenFieldName] : result.data.content
  
              return content;
            }
            else {
              return "";
            }
          } catch (error) {
            return ""
          } finally {
            setLoading(false);
          }
  
        } else {
          return "";
        }
      }
    } catch (err) {
      return "";
    } finally {
      setLoading(false);
    }
  }

  const getCustomFieldsByServiceId = async () => {
    try {
      setLoading(true);
      const response = await IntegrationServiceCustomFieldService.getCustomFieldsByServiceId(integrationServiceId);

      if (!response?.success) {
        alert("Error");
        return [];
      } else {
        return response?.data ?? []
      }
    } catch (err) {
      alert("Error");
      return [];
    } finally {
      setLoading(false);
    }
  } 

  useEffect(() => {
    const loadData = async () => {
      const _methodAuthIntegration = await getMethodAuthIntegration();
      const methodAuthIntegrationList = _methodAuthIntegration?.data?.authenticationmethodintegration ?? [];
      const _data = await getDataRequestById(integrationServiceId);

      setMethodAuthList(methodAuthIntegrationList);
      setData(_data);
      setUrl(_data?.url);
      setMethodAuthIntegrationService(methodAuthIntegrationList.find(item => item.id === _data?.methodauth) ?? {id: null, name: ""});

      // F6 rodada 8: pre-carrega defaultvalue dos rows pra o teste "just work"
      // sem exigir que o usuario preencha tudo do zero. Cada row vai pra state
      // com o valor default; user edita só o que quer sobreescrever.
      const paramsWithDefaults = (_data?.integrationserviceparams ?? []).map(p => ({
        id: p.id, name: p.name, ispathparam: p.ispathparam,
        value: p.defaultvalue ?? '',
      }));
      const headersWithDefaults = (_data?.integrationserviceheaders ?? []).map(h => ({
        id: h.id, name: h.name,
        value: h.value ?? h.defaultvalue ?? '',
      }));
      const bodyWithDefaults = (_data?.integrationservicerequestbody ?? [])
        .filter(b => Number(b?.type) !== 3)
        .map(b => ({
          id: b.id, name: b.name,
          value: b.defaultvalue ?? '',
        }));
      setParams(paramsWithDefaults);
      setHeaders(headersWithDefaults);
      setRequestBody(bodyWithDefaults);

      // Body JSON — pega o item type=3 se existir
      const jsonBodyItem = (_data?.integrationservicerequestbody ?? []).find(b => Number(b?.type) === 3);
      if (jsonBodyItem?.defaultvalue) {
        setJsonValue(jsonBodyItem.defaultvalue);
      }

      // Rebuild URL com path/query params já resolvidos
      if (paramsWithDefaults.some(p => p.value)) {
        let composed = _data?.url || '';
        const query = [];
        paramsWithDefaults.forEach(p => {
          if (!p.value) return;
          if (p.ispathparam) composed = composed.replace(`{${p.name}}`, encodeURIComponent(p.value));
          else query.push(`${encodeURIComponent(p.name)}=${encodeURIComponent(p.value)}`);
        });
        if (query.length) composed += '?' + query.join('&');
        setUrl(composed);
      }

      setLoadDataComponente(true);
      setLoading(false);
    }

    loadData();
  }, [integrationServiceId]);

  useEffect(() => {
    const loadTokenData = async () => {
      if (token) {
        setToken(token);
      } else if (data?.methodauth && data?.methodauth === 1 && data?.integrationauthid) {
        const fetchToken = await getToken(data?.integrationauthid);
        setToken(fetchToken);
      }
      setLoading(false);
    }

    loadTokenData();
  }, [token, data]);

  useEffect(() => {
    if (!contentRequest) return;
  
    const parseJsonData = (jsonData, key) => {
      if (key && jsonData.hasOwnProperty(key)) {
        return extractPrimitives(jsonData[key], data);
      } else if (jsonData) {
        return extractPrimitives(jsonData, data);
      }
      return [];
    };
  
    const mergeCustomFields = async (customFieldsList) => {
      const customFieldsRegistered = await getCustomFieldsByServiceId();
  
      return customFieldsList.map((customField) => {
        const customFieldRegistered = customFieldsRegistered.find(
          (cf) => cf?.name === customField?.fieldname
        );
  
        return customFieldRegistered
          ? {
              ...customField,
              id: customFieldRegistered.id,
              name: customFieldRegistered.sourcefieldname,
              isEditable: false,
            }
          : customField;
      });
    };
  
    const loadCustomFields = async () => {
      const jsonData = JSON.parse(contentRequest);
      const key = data?.objectname;
      const customFieldsList = parseJsonData(jsonData, key);
  
      if (customFieldsList.length > 0) {
        const customFieldsMerged = await mergeCustomFields(customFieldsList);
        setCustomFields(customFieldsMerged);
      }

      setLoading(false);
    };
  
    loadCustomFields();
  }, [contentRequest, data?.objectname]);


  // Booleans puros — sem isso valores 0/undefined vazam como "0" no JSX
  // (bug rodada 8: service com methodauth=0 renderizava "0" no canto do modal).
  const shouldShowBlockParameters = useMemo(() => !!(data?.integrationserviceparams?.length), [data]);

  const shouldShowBlockHeaders = useMemo(() => !!(data?.integrationserviceheaders?.length), [data]);

  const shouldShowBlockRequestBody = useMemo(() => !!(data?.requestbodytype && data?.requestbodytype !== 1), [data]);

  const shouldShowBlockMethodAuth = useMemo(() => data?.methodauth === 1 || data?.methodauth === 2, [data]);

  const shouldShowBlockCustomFields = useMemo(() => !!(customFields?.length), [customFields]);

  
  // functions
  const buildUrl = (paramsList) => {
    let url = data?.url;
    const queryParams = [];

    paramsList.forEach(param => {
      if (param?.value) {
        if (param.ispathparam) {
          url = url.replace(`{${param.name}}`, encodeURIComponent(param.value));
        } else {
          queryParams.push(`${encodeURIComponent(param.name)}=${encodeURIComponent(param.value)}`);
        }
      }
    });

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    setUrl(url);
  }

  const onValidateJson = (value) => {
    try {
      JSON.parse(value);
      setJsonError('');
    } catch (error) {
      setJsonError('JSON inválido');
    }
  };

  const handleChangeValueJson = (e) => {
    const value = e.target.value;
    setJsonValue(value);
    onValidateJson(value);
  };

  const updateValue = (id, value, state, setState, dataSource, isParams = false) => {
    const itemIndex = state.findIndex(item => item?.id === id);
    let newItems = [];

    if (itemIndex !== -1) {
      const updatedList = [...state];
      updatedList[itemIndex] = { ...updatedList[itemIndex], value };
      newItems = updatedList
      setState(updatedList);
    } else {
      const newItem = dataSource?.find(item => item?.id === id);
      if (newItem) {
        newItems = [...state, { ...newItem, value }]
        setState(prev => ([...prev, { ...newItem, value }]));
      }
    }

    if (isParams) {
      buildUrl(newItems)
    }
  };

  const handleChangeParams = (id, value) => updateValue(id, value, params, setParams, data?.integrationserviceparams, true); 

  const handleChangeHeaders = (id, value) => updateValue(id, value, headers, setHeaders, data?.integrationserviceheaders);

  const handleChangeRequestBody = (id, value) => updateValue(id, value, requestBody, setRequestBody, data?.integrationservicerequestbody);

  const getValue = (id, state) => state?.find(item => item?.id === id)?.value ?? "";

  const onGetParamValue = (id) => getValue(id, params);

  const onGetHeaderValue = (id) => getValue(id, headers);
  
  const onGetRequestBodyValue = (id) => getValue(id, requestBody);

  // F6 rodada 8: state estruturado do response — antes JSON.parse crashava
  // silenciosamente quando o body era HTML/text (ex.: 301, 500 HTML) e a UI
  // ficava totalmente vazia. Agora capturamos statuscode + reasonphrase + raw
  // separados e detectamos o tipo (json/html/text) pra render adequado.
  const [responseInfo, setResponseInfo] = useState(null);

  const handleSendRequest = async (e) => {
    e.preventDefault();
    setResponseInfo(null);
    setContentRequest(false);
    setShowContentRequest(false);
    setLoading(true);

    try {
      const payload = {
        url,
        method: data?.method,
        methodAuth: methodAuthIntegrationService?.id ?? null,
        token: _token,
        basicAuthUser,
        basicAuthPassword,
        headers,
        requestbodytype: data?.requestbodytype,
        requestBody,
        requestBodyJson: jsonValue
      };

      const result = await testRequestIntegrationService(payload);

      // BE devolve: { success, data: { success, reasonphrase, content, statuscode }, errors }
      const body = result?.data ?? {};
      const rawContent = body?.content ?? '';
      const statusCode = Number(body?.statuscode ?? 0);
      const reasonPhrase = body?.reasonphrase ?? '';
      const ok = statusCode >= 200 && statusCode < 300;

      // Deteccao de content-type do body (heuristica — BE nao devolve Content-Type)
      let contentType = 'text';
      let formatted = rawContent;
      const trimmed = (rawContent || '').trim();
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
          formatted = JSON.stringify(JSON.parse(trimmed), null, 2);
          contentType = 'json';
        } catch { /* nao era JSON valido — segue como text */ }
      } else if (trimmed.startsWith('<!DOCTYPE') || trimmed.startsWith('<html') || trimmed.startsWith('<')) {
        contentType = 'html';
      }

      setResponseInfo({
        statusCode,
        reasonPhrase,
        ok,
        contentType,
        raw: rawContent,
        formatted,
        size: rawContent ? new Blob([rawContent]).size : 0,
      });
      // Mantem compat com o useEffect legado que faz parse de custom fields.
      if (contentType === 'json') setContentRequest(formatted);
      setShowContentRequest(true);
    } catch (err) {
      // Erro de infra (network, 500 do proprio BE de teste) — mostra faixa vermelha.
      setResponseInfo({
        statusCode: err?.response?.status ?? 0,
        reasonPhrase: err?.message ?? 'Erro ao executar o teste.',
        ok: false,
        contentType: 'text',
        raw: err?.response?.data?.errors?.[0] ?? err?.message ?? '',
        formatted: err?.response?.data?.errors?.[0] ?? err?.message ?? '',
        size: 0,
      });
      setShowContentRequest(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <> 
      {
        (!loadDataComponent && isOpenFromJoint)
        ? <p>Carregando Informações ...</p>
        : (
          <>
            <Box className="box">
              <Typography component='h6' variant='h6' style={{ marginTop: '8px' }}>
                Url da requisição
              </Typography>

              <Box>
                <p>{url}</p>
              </Box>
            </Box>

            {shouldShowBlockParameters && (
              <Box className="box">
                <Typography component='h6' variant='h6' style={{ marginTop: '8px' }}>
                  Parâmetros da requisição
                </Typography>

                <Box>
                  {data?.integrationserviceparams?.map(param => (
                    <Box className="box-form-param" key={param?.id}>
                      <TextField 
                        inputProps={{ maxLength: 255 }} 
                        fullWidth 
                        label="Nome" 
                        autoComplete='fname' 
                        variant='outlined' 
                        name={param?.name}
                        value={param?.name} 
                        disabled
                      />

                      <TextField 
                        inputProps={{ maxLength: 255 }} 
                        fullWidth 
                        label="Valor" 
                        autoComplete='fname' 
                        variant='outlined' 
                        name='objectName' 
                        onChange={(e) => handleChangeParams(param?.id, e.target.value)} 
                        value={onGetParamValue(param?.id)}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {shouldShowBlockHeaders && (
              <Box className="box">
                <Typography component='h6' variant='h6' style={{ marginTop: '8px' }}>
                  Cabeçalho da requisição
                </Typography>

                <Box>
                  {data?.integrationserviceheaders?.map(param => (
                    <Box className="box-form-param" key={param?.id}>
                      <TextField 
                        inputProps={{ maxLength: 255 }} 
                        fullWidth 
                        label="Nome" 
                        autoComplete='fname' 
                        variant='outlined' 
                        name={param?.name}
                        value={param?.name} 
                        disabled
                      />

                      <TextField 
                        inputProps={{ maxLength: 255 }} 
                        fullWidth 
                        label="Valor" 
                        autoComplete='fname' 
                        variant='outlined' 
                        name='objectName' 
                        onChange={(e) => handleChangeHeaders(param?.id, e.target.value)}
                        value={onGetHeaderValue(param?.id)}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {shouldShowBlockRequestBody && (
              <Box className="box">
                <Typography component='h6' variant='h6' style={{ marginTop: '8px' }}>
                  Corpo da requisição
                </Typography>

                {/* F6 rodada 8: `2` (form-data) e `4` (x-www-form-urlencoded)
                    compartilham a mesma UI de rows Nome/Valor — o BE que decide
                    Content-Type pelo `requestbodytype`. Antes o bloco `=== 4`
                    NAO EXISTIA → services url-encoded abriam sem os campos e
                    o usuario nao conseguia digitar valor pra testar. */}
                {(data?.requestbodytype === 2 || data?.requestbodytype === 4) && (
                  <Box>
                    {/* Header discreto informando o formato */}
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                      Formato: {data?.requestbodytype === 4 ? 'x-www-form-urlencoded' : 'multipart/form-data'}
                    </Typography>
                    {(data?.integrationservicerequestbody ?? []).length === 0 && (
                      <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                        Nenhum campo cadastrado no body. Cadastre pelo editor de propriedades ou pelo CRUD do service pra habilitar o teste.
                      </Typography>
                    )}
                    {data?.integrationservicerequestbody?.map(param => (
                      <Box className="box-form-param" key={param?.id}>
                        <TextField
                          inputProps={{ maxLength: 255 }}
                          fullWidth
                          label="Nome"
                          autoComplete='fname'
                          variant='outlined'
                          name={param?.name}
                          value={param?.name}
                          disabled
                        />

                        <TextField
                          inputProps={{ maxLength: 255 }}
                          fullWidth
                          label="Valor"
                          autoComplete='fname'
                          variant='outlined'
                          name='objectName'
                          onChange={(e) => handleChangeRequestBody(param?.id, e.target.value)}
                          value={onGetRequestBodyValue(param?.id)}
                          placeholder={param?.defaultvalue || ''}
                        />
                      </Box>
                    ))}
                  </Box>
                )}

                {data?.requestbodytype === 3 && (
                  <StyledTextField
                    multiline
                    rows={10}
                    value={jsonValue}
                    onChange={handleChangeValueJson}
                    placeholder="Digite seu JSON aqui"
                    error={!!jsonError}
                    helperText={jsonError}
                  />
                )}
              </Box>
            )}

            {shouldShowBlockMethodAuth && (
              <Box className="box">
                <Typography component='h6' variant='h6' style={{ marginTop: '8px' }}>
                  Método de autenticação
                </Typography>

                <Box>
                  <Grid item xs={12} sm={12} style={{ marginBottom: '15px' }}>
                    <SimpleAutoComplete 
                      label={intl.formatMessage({ id: "authentication.method" })} 
                      options={methodAuthList && methodAuthList.length && methodAuthList.length > 0 ? methodAuthList : []} 
                      name="methodAuth" 
                      stateName='methodAuth' 
                      changeSelect={(stateName, value) => setMethodAuthIntegrationService(value)} 
                      selected={methodAuthIntegrationService} 
                    />
                  </Grid>

                  {methodAuthIntegrationService.id === 2 &&
                    <>
                      <Grid item xs={12} sm={12} style={{ marginBottom: '15px' }}>
                        <TextField 
                          inputProps={{ maxLength: 255 }} 
                          fullWidth label="Usuário da autenticação básica" 
                          variant='outlined' 
                          name='basicAuthUser' 
                          onChange={(e) => setBasicUser(e.target.value)}
                          value={basicAuthUser} 
                          required={methodAuthIntegrationService.id === 2 ? true : false} />
                      </Grid>

                      <Grid item xs={12} sm={12} style={{ marginBottom: '15px' }}>
                        <TextField 
                          inputProps={{ maxLength: 255 }} 
                          fullWidth label="Senha da autenticação básica" 
                          variant='outlined' 
                          name='basicAuthPassword' 
                          onChange={(e) => setBasicAuthPassword(e.target.value)} 
                          value={basicAuthPassword} 
                          required={methodAuthIntegrationService.id === 2 ? true : false} />
                      </Grid>
                    </>
                  }

                  {methodAuthIntegrationService.id === 1 &&
                    <>
                      <Grid item xs={12} sm={12} style={{ marginBottom: '15px' }}>
                        <TextField 
                          fullWidth 
                          label="Token" 
                          multiline
                          rows={10} 
                          variant='outlined' 
                          name='token' 
                          onChange={(e) => setToken(e.target.value)} 
                          value={_token} 
                        />
                      </Grid>
                    </>
                  }
                </Box>
              </Box>
            )}   

            {showContentRequest && responseInfo && (
              <Box className="box">
                <Typography component='h6' variant='h6' style={{ marginTop: '8px' }}>
                  Resultado da requisição
                </Typography>

                {/* Faixa de status Postman-style — pill colorida + reason + size.
                    Cores: verde 2xx, ambar 3xx, vermelho 4xx/5xx, cinza rede. */}
                <Box sx={{
                  display: 'flex', alignItems: 'center', gap: 1.5,
                  p: 1.25, mb: 1.5, borderRadius: 1.5,
                  background: responseInfo.ok
                    ? 'rgba(46,125,50,0.08)'
                    : responseInfo.statusCode >= 300 && responseInfo.statusCode < 400
                      ? 'rgba(237,108,2,0.08)'
                      : responseInfo.statusCode >= 400
                        ? 'rgba(211,47,47,0.08)'
                        : 'rgba(97,97,97,0.08)',
                  border: '1px solid',
                  borderColor: responseInfo.ok
                    ? 'rgba(46,125,50,0.4)'
                    : responseInfo.statusCode >= 300 && responseInfo.statusCode < 400
                      ? 'rgba(237,108,2,0.4)'
                      : responseInfo.statusCode >= 400
                        ? 'rgba(211,47,47,0.4)'
                        : 'rgba(97,97,97,0.4)',
                }}>
                  <Box sx={{
                    px: 1.25, py: 0.5, borderRadius: 1,
                    fontFamily: 'monospace', fontWeight: 700, fontSize: 13, color: '#fff',
                    background: responseInfo.ok ? '#2e7d32'
                      : responseInfo.statusCode >= 300 && responseInfo.statusCode < 400 ? '#ed6c02'
                      : responseInfo.statusCode >= 400 ? '#d32f2f'
                      : '#616161',
                  }}>
                    {responseInfo.statusCode || 'ERR'}
                  </Box>
                  <Typography variant="body2" sx={{ flex: 1, fontWeight: 500 }}>
                    {responseInfo.reasonPhrase || (responseInfo.ok ? 'Sucesso' : 'Falha')}
                  </Typography>
                  {responseInfo.size > 0 && (
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontFamily: 'monospace' }}>
                      {responseInfo.size < 1024
                        ? `${responseInfo.size} B`
                        : `${(responseInfo.size / 1024).toFixed(1)} KB`}
                    </Typography>
                  )}
                  <Box sx={{
                    px: 0.75, py: 0.25, borderRadius: 0.75, fontSize: 10,
                    background: 'rgba(0,0,0,0.06)', color: 'text.secondary',
                    fontFamily: 'monospace', textTransform: 'uppercase',
                  }}>
                    {responseInfo.contentType}
                  </Box>
                </Box>

                {/* Corpo — renderiza JSON formatado, HTML como pre (nao interpreta),
                    text como pre; sempre monospace, scroll interno, wrap opcional. */}
                {responseInfo.raw ? (
                  <Box sx={{
                    background: '#1e1e2e', color: '#e0e0e0',
                    fontFamily: "'Fira Code', 'Consolas', monospace",
                    fontSize: 12, lineHeight: 1.5,
                    p: 1.5, borderRadius: 1,
                    maxHeight: 400, overflow: 'auto',
                    whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                  }}>
                    {responseInfo.formatted}
                  </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    Sem body na resposta.
                  </Typography>
                )}
              </Box>
            )}

            {shouldShowBlockCustomFields && (
              <Box className="box">
                <Typography component='h6' variant='h6' style={{ marginTop: '8px' }}>
                  Campos personalizados
                </Typography>

                <EditableTableCustomFields 
                  customFields={customFields} 
                  serviceId={integrationServiceId}
                />
              </Box>
            )}

            <Grid item xs={12} sm={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Grid container justify="flex-end" spacing={2} style={{ justifyContent: 'flex-end' }}>
                <Grid item xs={12} sm={4}    >
                  <Button
                    onClick={handleSendRequest}
                    fullWidth
                    variant='contained'
                    color='primary'
                  >
                    {<FormattedMessage id="Testar" />}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </>
        )
      }

      {loading && (
          <Overlay>
              <CircularProgress color='secondary' />
          </Overlay>
      )}
    </>
  )
}

export default RequestIntegrationService;